import { configureStore } from "@reduxjs/toolkit";
import { ModelReducer } from "./slice";

// ***************************************************

const reducer = {
  model: ModelReducer,
};

// ***************************************************

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;
